import { TagEventsType } from "./eventTypes";

export const EVENT_NAME = {
  BTN_SEM_FIDELIDADE: "btn_sem_fidelidade",
  BTN_APPS_ILIMITADOS: "btn_apps_ilimitados",
  BTN_INDIQUE_E_GANHE: "btn_indique_e_ganhe",
  BTN_PAGAMENTO_FACIL: "btn_pagamento_facil",
  BTN_LIGACOES_ILIMITADAS: "btn_ligacoes_ilimitadas",
  BTN_BAIXA_APP_CLARO_FLEX_IOS: "btn_baixa_app_claro_flex_ios",
  BTN_BAIXA_APP_CLARO_FLEX_ANDROID: "btn_baixa_app_claro_flex_android",
  PAGE_VIEW_HOME: "page_home",
  CHECK_MANTER_NUMERO: "check_manter_numero",
  CHECK_TRAZER_DE_OUTRA_OPERADORA: "check_trazer_de_outra_operadora",
  CHECK_ADQUIRIR_NUMERO: "check_adquirir_numero",
  PAGE_VIEW_REGISTER: "page_new_register",
  BTN_CONTINUAR_DADOS_PESSOAIS: "continuar_dados_pessoais",
  BTN_CONTINUAR_CEP: "btn_continuar_cep",
  CLIQUE_MAIS_DETALHES: "clique_mais_detalhes",
  NAO_SEI_O_CEP: "nao_sei_o_cep",
  PAGE_VIEW_NEW_REGISTER_PHONE: "page_view_new_register_phone",
  PAGE_VIEW_NEW_REGISTER_SMS: "page_view_new_register_sms",
  PAGE_VIEW_NEW_REGISTER_BALANCE: "page_view_new_register_balance",
  BTN_PAGAR_CHECKOUT: "btn_pagar_checkout",
};

export const tagEvents: TagEventsType = {
  [EVENT_NAME.BTN_SEM_FIDELIDADE]: {
    event: "clique",
    custom_section: "claro-flex:home",
    custom_title: "clique:card-mais-vantagens:sem-fidelidade",
  },
  [EVENT_NAME.BTN_APPS_ILIMITADOS]: {
    event: "clique",
    custom_section: "claro-flex:home",
    custom_title: "clique:card-mais-vantagens:apps-ilimitados",
  },
  [EVENT_NAME.BTN_INDIQUE_E_GANHE]: {
    event: "clique",
    custom_section: "claro-flex:home",
    custom_title: "clique:card-mais-vantagens:indique-e-ganhe",
  },
  [EVENT_NAME.BTN_PAGAMENTO_FACIL]: {
    event: "clique",
    custom_section: "claro-flex:home",
    custom_title: "clique:card-mais-vantagens:pagamento-facil",
  },
  [EVENT_NAME.BTN_LIGACOES_ILIMITADAS]: {
    event: "clique",
    custom_section: "claro-flex:home",
    custom_title: "clique:card-mais-vantagens:ligacoes-ilimitadas",
  },
  [EVENT_NAME.BTN_BAIXA_APP_CLARO_FLEX_IOS]: {
    event: "clique",
    custom_section: "claro-flex:home",
    custom_title: "clique:banner-baixe-o-app-claro-flex:app-store",
  },
  [EVENT_NAME.BTN_BAIXA_APP_CLARO_FLEX_ANDROID]: {
    event: "clique",
    custom_section: "claro-flex:home",
    custom_title: "clique:banner-baixe-o-app-claro-flex:google-play",
  },
  [EVENT_NAME.BTN_PAGAR_CHECKOUT]: {
    event: "clique",
    custom_section: "claro-flex:checkout",
    custom_title: "clique:pagar",
  },
  [EVENT_NAME.PAGE_VIEW_HOME]: {
    event: "page_view",
    custom_section: "claro-flex:home",
  },
  [EVENT_NAME.PAGE_VIEW_REGISTER]: {
    event: "view_lead",
    custom_section: "claro-flex:new-register-confirm",
  },
  [EVENT_NAME.PAGE_VIEW_NEW_REGISTER_PHONE]: {
    event: "page_view",
    custom_section: "claro-flex:new-register-phone",
  },
  [EVENT_NAME.PAGE_VIEW_NEW_REGISTER_SMS]: {
    event: "page_view",
    custom_section: "claro-flex:new-register-sms",
  },
  [EVENT_NAME.PAGE_VIEW_NEW_REGISTER_BALANCE]: {
    event: "page_view",
    custom_section: "claro-flex:new-register-balance",
  },
  [EVENT_NAME.CHECK_MANTER_NUMERO]: {
    event: "clique",
    custom_section: "claro-flex:new-register-confirm",
    custom_title: "selecionou:manter-numero-claro",
  },
  [EVENT_NAME.CHECK_TRAZER_DE_OUTRA_OPERADORA]: {
    event: "clique",
    custom_section: "claro-flex:new-register-confirm",
    custom_title: "selecionou:trazer-numero-de-outra-operadora",
  },
  [EVENT_NAME.CHECK_ADQUIRIR_NUMERO]: {
    event: "clique",
    custom_section: "claro-flex:new-register-confirm",
    custom_title: "selecionou:adquirir-numero-claro",
  },
  [EVENT_NAME.BTN_CONTINUAR_DADOS_PESSOAIS]: {
    event: "clique",
    custom_section: "claro-flex:new-register-confirm",
    custom_title: "clique:continuar-dados-pessoais",
  },
  [EVENT_NAME.BTN_CONTINUAR_CEP]: {
    event: "clique",
    custom_section: "claro-flex:new-register-confirm",
    custom_title: "clique:continuar-cep",
  },
  [EVENT_NAME.CLIQUE_MAIS_DETALHES]: {
    event: "clique",
    custom_section: "claro-flex:home",
  },
  [EVENT_NAME.NAO_SEI_O_CEP]: {
    event: "clique",
    content_type: "claro-flex:new-register-confirm",
    item_id: "clique:nao_sei_o_cep",
  },
};
